import { api } from "@/shared/api";

// local-only: 1010 客服 H5 端一期补完契约 5(企微欢迎语写入口),codegen 尚未覆盖。
export type KefuWelcome = {
  /** ≤200;空串 = 使用默认欢迎语 */
  text: string;
};

export const KEFU_WELCOME_MAX = 200;

/**
 * 默认欢迎语 —— 与 api `CsInboundService.DEFAULT_WELCOME` 逐字一致(只用于前端占位提示「不填会显示什么」,
 * 真正发给客户的永远是后端那一份;两边改要一起改)。
 */
export const DEFAULT_KEFU_WELCOME =
  "您好，我是智能客服，产品、价格、使用问题都可以直接问我。想先了解哪一块？";

export const KEFU_WELCOME_QUERY_KEY = ["cs-welcome"] as const;

const BASE = "/tenant/customer-service/welcome";

export const kefuWelcomeService = {
  get: () => api.get<KefuWelcome>(BASE),
  put: (text: string) => api.put<KefuWelcome>(BASE, { text }),
};

/** 租户实际生效的欢迎语:设了用设的,没设 / 查不到用默认。 */
export function effectiveWelcome(w: KefuWelcome | undefined): string {
  const t = w?.text?.trim();
  return t ? t : DEFAULT_KEFU_WELCOME;
}
